<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">Record {{parentdata.trackingName}} data</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

   <mat-dialog-content style="padding-bottom: 0px;padding-top: 10px;">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Measurement/reading</mat-label>
        <input [(ngModel)]="trackingItemValue" matInput #input type="number" smDecimalOnly/>
      </mat-form-field>
    </div>
      <div>
    <mat-form-field
      class="w-100"
      appearance="outline"
      class="col-12"
      (click)="picker0.open()"
      style="padding: 0px"
    >
      <mat-label>Reading date</mat-label>
      <input
            [(ngModel)]="trackingDate"
        [max]="today"
        matInput
        [matDatepicker]="picker0"
        readonly
      />

      <mat-datepicker-toggle matSuffix [for]="picker0"></mat-datepicker-toggle>
      <mat-datepicker #picker0 disabled="false"></mat-datepicker>
    </mat-form-field>
  </div>

    <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Notes (Optional)</mat-label>
      <textarea [(ngModel)]="trackingNotes" matInput></textarea>
    </mat-form-field>
  </div>

    </mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="accent" [disabled]="!trackingItemValue || !trackingDate" (click)="onSave()">Save</button>
</mat-dialog-actions>